import { FC } from 'react';
import { RadioGroup, Form, Radio } from 'rsuite';
import { BrandSelection } from '../BrandSelection';
import { ManualSelection } from '../ManualSelection';
import styles from './productSelectMode.module.scss';
import { SelectPattern } from 'core/rtbCampaign/singlePage/common';

interface ProductSelectProps {
  selectPattern: SelectPattern;
  brandOptions: any[];
  defaultForm: any;
  onSelectPatternChange: (v: SelectPattern) => void;
  brand: string | null;
  onBrandChange: (v: string | null) => void;
  errorMessage: object;
  closeProductManager: () => void;
  disabled?: boolean;
  disabledText?: string;
  availableProducts: number;
}

export const ProductSelectMode: FC<ProductSelectProps> = ({
  selectPattern,
  defaultForm,
  brandOptions,
  onSelectPatternChange,
  brand,
  onBrandChange,
  errorMessage,
  closeProductManager,
  disabled = false,
  disabledText = '',
  availableProducts,
}) => {
  const handleProductTypeChange = (newProductType) => {
    onSelectPatternChange(newProductType);
  };
  const handleBrandChange = (v) => {
    onBrandChange(v);
  };

  return (
    <>
      <div className={styles['product-select_wrapper']}>
        <RadioGroup
          value={selectPattern}
          onChange={handleProductTypeChange}
          inline
        >
          <div className={styles['product-select_container']}>
            <Radio
              value={SelectPattern.AUTO}
              disabled={disabled}
              className={styles['product-select__radio']}
            >
              智能選品
            </Radio>
            <div className={styles['product-select__hint']}>
              <Form.HelpText>
                {disabledText || '動態調整投廣商品(此功能僅限部分廣告主)'}
              </Form.HelpText>
            </div>
          </div>
          <div className={styles['product-select_container']}>
            <Radio
              value={SelectPattern.MANUAL}
              className={styles['product-select__radio']}
            >
              手動選品
            </Radio>
            <div className={styles['product-select__hint']}>
              <Form.HelpText>手動選擇投廣商品</Form.HelpText>
            </div>
          </div>
        </RadioGroup>
        <div className={styles['product-select__selector']}>
          {selectPattern === SelectPattern.AUTO && (
            <BrandSelection
              data={brandOptions}
              value={brand}
              onChange={handleBrandChange}
              errorMessage={errorMessage}
            />
          )}
          {selectPattern === SelectPattern.MANUAL && (
            <ManualSelection
              availableProducts={availableProducts}
              errorMessage={errorMessage}
              customButtom={
                '當異動已選商品時，若您選擇手動出價與選字，將清空已設定的出價與選字'
              }
            />
          )}
        </div>
      </div>
    </>
  );
};
